// extracted by mini-css-extract-plugin
module.exports = {"success-text":"a10a3f92e9--success-text--2qJcB","success-email":"a10a3f92e9--success-email--it4Ze"};